import React, { useEffect, useState } from "react"

import { withZoomState } from "../../config/ZoomConfigProvider"
import { withPlotSettingsConfig } from "../../config/PlotSettingsConfigProvider"
import AbstractGraphSelectionArea from "../resources/AbstractGraphSelectionArea"

const ZoomSelectionLayer = ({
  x,
  y,
  y2,
  margin,
  fullY,
  zoomKey,
  zoomGraphKey,
  baseTime,
  xNotTime,
  timeExtractor, // From PlotSettingsConfigProvider
  zoomConfig, // From ZoomConfigProvider
}) => {
  const onSelect = (xChanged, yChanged, y2Changed, minX, maxX, minY1, maxY1, minY2, maxY2) => {
    const nonTimeZoom = {}
    let nonTimeZoomDirty = false

    // Although we make separate calls here, Reacts update batching should ensure that
    // these never get separated.
    if (xChanged || yChanged || y2Changed) {
      if (xChanged) {
        if (!xNotTime) {
          zoomConfig.zoomTime(
            timeExtractor.difference(minX, baseTime),
            timeExtractor.difference(maxX, baseTime),
          )
        } else {
          nonTimeZoom.x = [minX, maxX]
          nonTimeZoomDirty = true
        }
      }

      if (yChanged || y2Changed) {
        if (yChanged) {
          nonTimeZoom.y = [minY1, maxY1]
          nonTimeZoomDirty = true
        }
        if (y2Changed) {
          nonTimeZoom.y2 = [minY2, maxY2]
          nonTimeZoomDirty = true
        }
      }

      if (nonTimeZoomDirty) {
        zoomConfig.zoomPlot(zoomGraphKey, zoomKey, nonTimeZoom)
      }

      zoomConfig.setZoomMode(false)
    }
  }

  const [selecting, setSelecting] = useState(false)
  useEffect(() => {
    setSelecting(zoomConfig?.isZoomMode() || false)
  }, [zoomConfig])

  return (
    <AbstractGraphSelectionArea
      x={x}
      y={y}
      y2={y2}
      margin={margin}
      fullY={fullY}
      onSelect={onSelect}
      selecting={selecting}
      canSelectX
      canSelectY
    />
  )
}

export default withPlotSettingsConfig(withZoomState(ZoomSelectionLayer))
